function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#2FCEEB;}\r\n\t.st1{fill:#6CC7E3;}\r\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M26,51.2c0,5.9-4.5,10.6-10.8,11.3c-0.2,0.1-0.4,0.1-9.6,0.1v13.9c0,1.6-1.3,2.8-2.8,2.8 c-1.6,0-2.8-1.3-2.8-2.8V42.8C0,41.3,1.3,40,2.8,40c0,0,8,0,12.2,0C21.2,40.3,26,45.2,26,51.2z M14.6,57c3.2,0,5.8-2.5,5.9-5.7 c-0.1-3.1-2.7-5.5-5.9-5.5H5.7v11.3L14.6,57L14.6,57z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M54,65.5v11c0,1.6-1.2,2.8-2.8,2.8c-1.1,0-2.7-1.2-2.7-2.8c-2.4,2-5.2,2.8-8.4,2.8c-8,0-14.2-5.9-14.2-13.8 c0-8,6.3-14.2,14.2-14.2C48.1,51.2,54,57.5,54,65.5z M48.4,65.5c0-4.7-3.6-8.8-8.4-8.8c-4.7,0-8.8,4-8.8,8.8c0,4.7,4,8.4,8.8,8.4 C44.8,73.8,48.4,70.2,48.4,65.5z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M74.3,53.9c0,1.5-1.3,2.8-2.8,2.8c-4.7,0-8.5,3.8-8.5,8.5v11.3c0,1.5-1.3,2.8-2.7,2.8c-1.6,0-2.8-1.3-2.8-2.8 V65.3c0-7.8,6.3-14.1,14.1-14.1C73.1,51.2,74.3,52.4,74.3,53.9z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M74.1,65.3c0-7.8,6.3-14.1,14.1-14.1s14.1,6.3,14.1,14.1c0,7.7-6.3,14.1-14.1,14.1S74.1,73,74.1,65.3z  M79.7,65.3c0,4.7,3.8,8.5,8.5,8.5c4.7,0,8.5-3.9,8.5-8.5c0-4.7-3.8-8.5-8.5-8.5C83.5,56.7,79.7,60.5,79.7,65.3z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M105.7,65.3c0-7.8,6.3-14.1,14.1-14.1c7.8,0,14.1,6.3,14.1,14.1c0,7.7-6.3,14.1-14.1,14.1 C112,79.4,105.7,73,105.7,65.3z M111.3,65.3c0,4.7,3.8,8.5,8.5,8.5c4.7,0,8.5-3.9,8.5-8.5c0-4.7-3.8-8.5-8.5-8.5 C115.1,56.7,111.3,60.5,111.3,65.3z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M159.4,70.1v20.6c0,1.4-1,2.4-2.4,2.4c-1.4,0-2.4-1-2.4-2.4v-9.1h0.5c1.9,0,3.4-1.4,3.4-3.4v-7.5 C159,70.6,159.2,70.3,159.4,70.1z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M154.1,81.6v2.9c0,1.4-1,2.4-2.4,2.4c-1.4,0-2.4-1-2.4-2.4V66.7c0.5,0.5,2.4,1.9,2.4,1.9v10.1 C151.7,80.2,152.7,81.6,154.1,81.6z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M157.5,71.1v7.7c0,1.4-1,2.4-2.4,2.4h-0.5c-1.4,0-2.4-1-2.4-2.4v-9.6C155.8,71.4,157,71.1,157.5,71.1z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M148.9,66.3c-1.5-0.7-5.8-5.3-8.2-9.1c-7.2-11-7.7-25-1-30.2c0,0,0.5-0.5,0.5-0.5c0.1,0.7,1.8,4.5,2.2,5 l0.1,0.1c0,0-0.2,0.2-0.5,0.6c-1.4,2.9-2.9,6.2-2.9,10.1c0,0.5,0,1.4,0,1.9c0,4.3,1.4,9.6,4.3,14.4 C144.5,60.5,147.9,65.8,148.9,66.3z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M156.5,0c-9.6,0-16.8,8.6-16.8,19.7c0-0.5,0,0.5,0,0c0,1,0.2,3.7,1,6.2c0.8,2.6,2.4,4.8,2.4,4.8 s0.9-1.7,2.4-3.2c1.4-1.4,6-3.5,6.2-3.5c0,0-1.2-2.1-1.2-5.8c0-7.4,5-13.4,10.3-13.4C160.8,4.8,161.6,0,156.5,0z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M164.2,19.2c-1,1.9-2.9,2.9-4.8,3.4v-8.2L164.2,19.2z"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M169,13.9c0,2.4-1,4.3-2.4,6.2l-0.2,0.3l-7-6.5V4.3C164.7,4.3,169,8.6,169,13.9z"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M163.2,32.6c0.5-2.9-1-4.8-3.4-4.8h-0.5c-4.6-0.2-6.7-2.4-6.7-2.4c-0.5,0-2.4,0.3-4.7,1.3 c-1.3,0.6-2.3,1.7-3.4,3.1c-2.4,2.9-4.3,7.7-4.8,12.5c0,0.5,0,1,0,1.9c0,3.8,1.4,9.1,4.3,14.4c1,1.9,2.4,3.4,3.4,4.8 c1.4,1.9,2.9,3.4,4.3,4.3c0,0,0.4,0.3,0.5,0.5c1.4,1,2.9,1.9,4.3,2.4c1.4,0.5,3.4-1,3.4-2.9L163.2,32.6z"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M155.1,13.4c0.8,0,1.4-0.6,1.4-1.4c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.6-1.4,1.4 C153.7,12.8,154.3,13.4,155.1,13.4z"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M151.7,20.6c0-0.2,0-0.3,0-0.5C151.7,20.3,151.7,20.5,151.7,20.6z"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M151.7,20c0-0.1,0-0.2,0-0.3C151.7,19.8,151.7,19.9,151.7,20z"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M151.7,20C151.7,20,151.7,20.1,151.7,20C151.7,20.1,151.7,20,151.7,20C151.7,20,151.7,20,151.7,20z"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M153.5,24.8c0.2,0.3,0.5,0.5,0.8,0.8l-0.1-0.1C153.9,25.2,153.7,25,153.5,24.8z"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M151.7,20.6C151.7,20.6,151.7,20.6,151.7,20.6C151.7,20.7,151.7,20.7,151.7,20.6 C151.7,20.6,151.7,20.6,151.7,20.6z"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M159.4,22.6c-0.5,0-2.3,0.7-7.7-2.9c0,0,0,0,0,0c0,0.1,0,0.2,0,0.3c0,0,0,0,0,0.1c0,0.2,0,0.4,0,0.5 c0,0,0,0,0,0c0,0,0,0,0,0c0.1,1.6,0.8,3,1.7,4.1c0.2,0.2,0.4,0.4,0.7,0.7l0.1,0.1c1.2,1,2.7,1.6,4.3,1.6c0.3,0,0.5,0,0.8-0.1 c0-0.1,0.1-0.2,0.1-0.2V22.6z"
});

var SvgParooBlue = function SvgParooBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 169 94",
    style: {
      enableBackground: "new 0 0 169 94"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgParooBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/parooBlue.67f4af9c.svg";
export { ForwardRef as ReactComponent };